<script setup lang="ts">
import { useInputActivationDuration } from '../../../model/additional-info/support/info-manual-activation/input-activation-duration.hook'
import { useSelectActivationType } from '../../../model/additional-info/support/info-manual-activation/select-activation-type.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import InputActivationDuration from './info-manual-activation/InputActivationDuration.vue'
import SelectActivationType from './info-manual-activation/SelectActivationType.vue'

defineOptions({
  name: 'InfoManualActivation',
})

const { isRequired: isRequiredActivationType } = useSelectActivationType()
const { isRequired: isRequiredActivationDuration } = useInputActivationDuration()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Activation type"
      :required="isRequiredActivationType"
    >
      <SelectActivationType />
    </RowTaskInfo>
    <RowTaskInfo
      title="Activation duration"
      :required="isRequiredActivationDuration"
    >
      <InputActivationDuration />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
